const ManagerBase = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
			{
				title: '附件中心',
				key: 'BillList'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
	{
		title: '设置',
		key: 'Setting',
		icon: '设置',
		icons: '设置（选中）',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '期初',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			}, {
				title: '辅助核算',
				key: 'AssistingAccounting'
			}/*, {
				title: '凭证模板',
				key: 'TemplateManager'
			}*/, {
				title: '权限设置',
				key: 'PermissionSetting'
			}, {
				title: '备份恢复',
				key: 'BakUp'
			}, /*{
				title: '归档管理',
				key: 'ArchiveManagement'
			}*/

		]
	}
];

const ManagerLow = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
			{
				title: '附件中心',
				key: 'BillList'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
	{
		title: '设置',
		key: 'Setting',
		icon: '设置',
		icons: '设置（选中）',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '期初',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			}/*, {
				title: '凭证模板',
				key: 'TemplateManager'
			}*/, {
				title: '权限设置',
				key: 'PermissionSetting'
			}, {
				title: '备份恢复',
				key: 'BakUp'
			}, /*{
				title: '归档管理',
				key: 'ArchiveManagement'
			}*/

		]
	}
];

const ManagerMajor = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
			{
				title: '附件中心',
				key: 'BillList'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'EmployeeInformation'
			},
			{
				title: '五险一金设置',
				key: 'InsureIndex'
			},
		]
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '固定资产管理',
				key: 'Assets'
			},
			{
				title: '固定资产类别',
				key: 'AssetsType'
			},
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
			/*{
				title: '固定资产对账',
				key: 'AssetsCheck'
			}*/
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
	{
		title: '设置',
		key: 'Setting',
		icon: '设置',
		icons: '设置（选中）',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '期初',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			}, {
				title: '辅助核算',
				key: 'AssistingAccounting'
			}/*, {
				title: '凭证模板',
				key: 'TemplateManager'
			}*/, {
				title: '权限设置',
				key: 'PermissionSetting'
			}, {
				title: '备份恢复',
				key: 'BakUp'
			}, /*{
				title: '归档管理',
				key: 'ArchiveManagement'
			}*/

		]
	}
];
const ManagerFlagship = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
			{
				title: '附件中心',
				key: 'BillList'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: []
	},
	{
		title: '分析',
		key: 'AnalysisList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			{
				title: '费用明细表',
				key: 'ProfitSubjectBalance'
			},
			{
				title: '经营状况表',
				key: 'OperateSubjectBalance'
			},
			{
				title: '账龄分析表',
				key: 'AgingReport'
			},
			{
				title: '应收分析表',
				key: 'ArAnalysis'
			},
			{
				title: '应付分析表',
				key: 'ApAnalysis'
			},
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'EmployeeInformation'
			},
			{
				title: '五险一金设置',
				key: 'InsureIndex'
			},
		]
	},
	{
		title: '资金',
		key: 'funds',
		icon: '资金',
		icons: '资金（选中）',
		children: [
			{
				title: '日记账',
				key: 'CashierJournal'
			},
			{
				title: '内部转账',
				key: 'InternalTransfer'
			},
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
			{
				title: '收支类别',
				key: 'CashierIoType'
			},
			{
				title: '账户设置',
				key: 'CashierAccount'
			}
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: '发票',
		icons: '发票（选中）',
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '固定资产管理',
				key: 'Assets'
			},
			{
				title: '固定资产类别',
				key: 'AssetsType'
			},
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
			/*{
				title: '固定资产对账',
				key: 'AssetsCheck'
			}*/
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
	{
		title: '设置',
		key: 'Setting',
		icon: '设置',
		icons: '设置（选中）',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '期初',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			}, {
				title: '辅助核算',
				key: 'AssistingAccounting'
			}/*, {
				title: '凭证模板',
				key: 'TemplateManager'
			}*/, {
				title: '权限设置',
				key: 'PermissionSetting'
			}, {
				title: '备份恢复',
				key: 'BakUp'
			}, /*{
				title: '归档管理',
				key: 'ArchiveManagement'
			}*/

		]
	}
];
const ManagerApexe = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
			{
				title: '附件中心',
				key: 'BillList'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			
		]
	},
	{
		title: '分析',
		key: 'AnalysisList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			{
				title: '费用明细表',
				key: 'ProfitSubjectBalance'
			},
			{
				title: '经营状况表',
				key: 'OperateSubjectBalance'
			},
			{
				title: '账龄分析表',
				key: 'AgingReport'
			},
			{
				title: '应收分析表',
				key: 'ArAnalysis'
			},
			{
				title: '应付分析表',
				key: 'ApAnalysis'
			},
		]
	},
	{
		title: '税务',
		key: 'TaxList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'EmployeeInformation'
			},
			{
				title: '五险一金设置',
				key: 'InsureIndex'
			},
		]
	},
	{
		title: '资金',
		key: 'funds',
		icon: '资金',
		icons: '资金（选中）',
		children: [
			{
				title: '日记账',
				key: 'CashierJournal'
			},
			{
				title: '内部转账',
				key: 'InternalTransfer'
			},
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
			{
				title: '收支类别',
				key: 'CashierIoType'
			},
			{
				title: '账户设置',
				key: 'CashierAccount'
			}
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: '发票',
		icons: '发票（选中）',
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '固定资产管理',
				key: 'Assets'
			},
			{
				title: '固定资产类别',
				key: 'AssetsType'
			},
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
			/*{
				title: '固定资产对账',
				key: 'AssetsCheck'
			}*/
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
	{
		title: '设置',
		key: 'Setting',
		icon: '设置',
		icons: '设置（选中）',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '期初',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			}, {
				title: '辅助核算',
				key: 'AssistingAccounting'
			}/*, {
				title: '凭证模板',
				key: 'TemplateManager'
			}*/, {
				title: '权限设置',
				key: 'PermissionSetting'
			}, {
				title: '税务信息',
				key: 'TaxInformation'
			},
			{
				title: '审计数据',
				key: 'AuditDataExport'
			},
			{
				title: '备份恢复',
				key: 'BakUp'
			}, /*{
				title: '归档管理',
				key: 'ArchiveManagement'
			}*/

		]
	}
];

const MakingLow = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
];

const MakingBase = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
];
const MakingMajor = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'EmployeeInformation'
			},
			{
				title: '五险一金设置',
				key: 'InsureIndex'
			},
		]
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '固定资产管理',
				key: 'Assets'
			},
			{
				title: '固定资产类别',
				key: 'AssetsType'
			},
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
];
const MakingFlagship = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
	{
		title: '分析',
		key: 'AnalysisList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			{
				title: '费用明细表',
				key: 'ProfitSubjectBalance'
			},
			{
				title: '经营状况表',
				key: 'OperateSubjectBalance'
			},
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'EmployeeInformation'
			},
			{
				title: '五险一金设置',
				key: 'InsureIndex'
			},
		]
	},
	{
		title: '资金',
		key: 'funds',
		icon: '资金',
		icons: '资金（选中）',
		children: [
			{
				title: '日记账',
				key: 'CashierJournal'
			},
			{
				title: '内部转账',
				key: 'InternalTransfer'
			},
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
			{
				title: '收支类别',
				key: 'CashierIoType'
			},
			{
				title: '账户设置',
				key: 'CashierAccount'
			}
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: '发票',
		icons: '发票（选中）',
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '固定资产管理',
				key: 'Assets'
			},
			{
				title: '固定资产类别',
				key: 'AssetsType'
			},
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
];

const MakingApexe = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
	{
		title: '分析',
		key: 'AnalysisList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			{
				title: '费用明细表',
				key: 'ProfitSubjectBalance'
			},
			{
				title: '经营状况表',
				key: 'OperateSubjectBalance'
			},
			{
				title: '账龄分析表',
				key: 'AgingReport'
			},
			{
				title: '应收分析表',
				key: 'ArAnalysis'
			},
			{
				title: '应付分析表',
				key: 'ApAnalysis'
			},
		]
	},
	{
		title: '税务',
		key: 'TaxList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
			{
				title: '员工信息',
				key: 'EmployeeInformation'
			},
			{
				title: '五险一金设置',
				key: 'InsureIndex'
			},
		]
	},
	{
		title: '资金',
		key: 'funds',
		icon: '资金',
		icons: '资金（选中）',
		children: [
			{
				title: '日记账',
				key: 'CashierJournal'
			},
			{
				title: '内部转账',
				key: 'InternalTransfer'
			},
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
			{
				title: '收支类别',
				key: 'CashierIoType'
			},
			{
				title: '账户设置',
				key: 'CashierAccount'
			}
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: '发票',
		icons: '发票（选中）',
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '固定资产管理',
				key: 'Assets'
			},
			{
				title: '固定资产类别',
				key: 'AssetsType'
			},
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
		]
	},
	{
		title: '期末结转',
		key: 'Checkout',
		icon: '期末结转',
		icons: '期末结转（选中）',
	},
];


const ViewLow = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
];

const ViewBase = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
];
const ViewMajor = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
		]
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
		]
	},
];
const ViewFlagship = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
		
		]
	},
	{
		title: '分析',
		key: 'AnalysisList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			{
				title: '费用明细表',
				key: 'ProfitSubjectBalance'
			},
			{
				title: '经营状况表',
				key: 'OperateSubjectBalance'
			},
		]
	},

	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
		]
	},
	{
		title: '资金',
		key: 'funds',
		icon: '资金',
		icons: '资金（选中）',
		children: [
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: '发票',
		icons: '发票（选中）',
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
		]
	},
];

const ViewApexe = [
	{
		title: '首页',
		key: 'Home',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '凭证',
		key: 'Voucher',
		icon: '凭证',
		icons: '凭证（选中）',
		children: [
			{
				title: '凭证查询',
				key: 'Voucher'
			},
			{
				title: '凭证汇总',
				key: 'SubjectSummary'
			},
		]
	},
	{
		title: '账簿',
		key: 'AccountBook',
		icon: '账簿',
		icons: '账簿（选中）',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '外币明细账',
				key: 'CurrencyDetailedAccounts'
			},
			{
				title: '数量明细账',
				key: 'QuantityDetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '科目余额表',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '多栏账',
				key: 'MultiDetailedAccounts'
			}
		]
	},
	
	{
		title: '报表',
		key: 'ReportList',
		icon: '报表',
		icons: '报表（选中）',
		children: [

		]
	},
	{
		title: '分析',
		key: 'AnalysisList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			{
				title: '费用明细表',
				key: 'ProfitSubjectBalance'
			},
			{
				title: '经营状况表',
				key: 'OperateSubjectBalance'
			},
			{
				title: '账龄分析表',
				key: 'AgingReport'
			},
			{
				title: '应收分析表',
				key: 'ArAnalysis'
			},
			{
				title: '应付分析表',
				key: 'ApAnalysis'
			},
		]
	},

	{
		title: '税务',
		key: 'TaxList',
		icon: '报表',
		icons: '报表（选中）',
		children: [
			
		]
	},
	{
		title: '工资',
		key: 'Salary',
		icon: '工资',
		icons: '工资（选中）',
		children: [
			{
				title: '工资管理',
				key: 'Salary'
			},
		]
	},
	{
		title: '资金',
		key: 'funds',
		icon: '资金',
		icons: '资金（选中）',
		children: [
			{
				title: '资金报表',
				key: 'FundsReport'
			},
			{
				title: '核对总账',
				key: 'CheckUp'
			},
		]
	},
	{
		title: '发票',
		key: 'Invoice',
		icon: '发票',
		icons: '发票（选中）',
	},
	{
		title: '固定资产',
		key: 'assets',
		icon: '固定资产',
		icons: '固定资产（选中）',
		children: [
			{
				title: '折旧明细表',
				key: 'AssetsDepreciationList'
			},
			{
				title: '固定资产汇总',
				key: 'AssetsSummary'
			},
		]
	},
];

const EnterpriseWorkbench = [
	{
		title: '应用列表',
		key: 'ApplicationList',
		icon: '首页icon',
		icons: '首页（选中）',
	},
	{
		title: '产品激活',
		key: 'ProductActivation',
		icon: '凭证',
		icons: '凭证（选中）',
	},
	{
		title: '个人中心',
		key: 'PersonalCenter',
		icon: '设置',
		icons: '设置（选中）',
	}
];

export default {
	ManagerBase,
    MakingBase,
    ViewBase,
    ManagerMajor,
    MakingMajor,
    ViewMajor,
    ManagerFlagship,
    MakingFlagship,
    ViewFlagship,
	ManagerApexe,
    MakingApexe,
    ViewApexe,
	ManagerLow,
    MakingLow,
    ViewLow,
	EnterpriseWorkbench
};